module.exports = __webpack_public_path__ + "img/40_38_078_060.5b6cafc0.jpg";